import { createFileRoute } from "@tanstack/react-router";
import Sitemap from "@/pages/Sitemap";
import { buildBreadcrumbLd } from "@/lib/structured-data";

const title = "Sitemap - Gatlinburg Wine Trail";
const description =
  "Browse all pages on the Gatlinburg Wine Trail website. Find trail info, checkout, blog posts, and more.";

export const Route = createFileRoute("/_sticky/sitemap")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://demo.gatlinburgwinetrail.com/sitemap" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbLd([{ name: "Sitemap", path: "/sitemap" }]),
        ),
      },
    ],
    links: [
      { rel: "canonical", href: "https://demo.gatlinburgwinetrail.com/sitemap" },
    ],
  }),
  component: Sitemap,
});
